import React, { useState } from 'react';

import {
    AlertAction,
    AlertActionContext,
} from 'components/ChartAlert/Contexts/AlertActionContext';

type Props = {
    children: JSX.Element;
};

const AlertActionProvider = ({ children }: Props): JSX.Element => {
    const [action, setAction] = useState<AlertAction>({ name: 'list' });

    const alertActionState = {
        action,
        setAction,
    };

    return (
        <AlertActionContext.Provider value={alertActionState}>
            {children}
        </AlertActionContext.Provider>
    );
};

export default AlertActionProvider;
